import { Component, input, OnInit, output, signal } from '@angular/core';
import { DataTable, IDataClassConfig } from 'app/classes/data-table/data-table';
import { IssueTrackingService, ITrackingIssue, ITrackingIssueAudit } from 'app/shared/issue-tracking.service';

@Component({
  selector: 'app-issue-tracking-audit',
  standalone: false,
  templateUrl: './issue-tracking-audit.component.html',
  styleUrl: './issue-tracking-audit.component.css'
})
export class IssueTrackingAuditComponent implements OnInit {
  audit = signal<any>(null);
  auditItem = signal<ITrackingIssueAudit>(null);
  issue = input.required<ITrackingIssue>();
  comment: string;

  dataTable = signal<DataTable>(null);
  dataTableConfig: IDataClassConfig = {
    "createdAt": { valueType: "date", title: "Updated", align: "left", width: 150 },
    "action": { "valueType": "string", "title": "Action", "align": "left", "width": 100 },
    "createdByName": { "valueType": "string", "title": "User", "align": "left", width: 140 },
    "message": { "valueType": "string", "title": "Message", "align": "left" }
  };


  onCompleteIssueUsingDate = output<Date>();

  constructor(private issueTracking: IssueTrackingService) {

  }

  ngOnInit(): void {
    this.dataTable.set(new DataTable({ data: this.issue().audits.toSorted((a, b) => a.createdAt > b.createdAt ? -1 : 1), sortedColumns: [] }, this.dataTableConfig));
  }

  rowClick(item: ITrackingIssueAudit) {
    this.auditItem.set(item);
  }

  completeIssue() {
    this.onCompleteIssueUsingDate.emit(this.auditItem().createdAt);
    this.auditItem.set(null);
  }

}
